import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../generic/CustomBtn';
import { initIPFS } from '../../../../../state/ipfs';
import Loader from '../../../../Loader';

export const CoverPhotoPreview = ({ resizedImage, setResizedImage, showResizedPhoto, setShowResizedPhoto, setIconCid }) => {
  const translate = useIntl();
  const [isSavedToIpfs, setIsSavedToIpfs] = useState(false);

  const sendCoverPhotoToIpfs = async (arrBuff, path) => {
    if (!arrBuff) {
      return null;
    }

    try {
      const buffer = Buffer.from(arrBuff);
      const data = [{
        content: buffer,
        path,
      }];

      const ipfs = await initIPFS();

      let cid = '';
      for await (const result of ipfs.addAll(data)) {
        cid = `/ipfs/${result.cid.string}`;
      }
      return cid || null;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const convertFileToArrBuffer = (blob) => new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(blob);
    fileReader.onload = function (event) {
      const arrayBuffer = event.target.result;
      resolve(arrayBuffer);
    };
  });

  const saveDataToIPFS = async () => {
    setIsSavedToIpfs(true);
    const bigArrBuffer = await convertFileToArrBuffer(resizedImage.largeCoverPhotoBlob);
    const smallArrBuffer = await convertFileToArrBuffer(resizedImage.smallCoverPhotoBlob);

    const [largeIconCid, smallIconCid] = await Promise.all([
      sendCoverPhotoToIpfs(bigArrBuffer, ''),
      sendCoverPhotoToIpfs(smallArrBuffer, ''),
    ]);

    if (largeIconCid && smallIconCid) {
      setShowResizedPhoto(false);
      setIconCid({
        iconCidDir: largeIconCid,
        secondIconCidDir: smallIconCid,
      });
      setIsSavedToIpfs(false);
    }
  };

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const removeIcon = () => {
    setResizedImage({
      ...resizedImage,
      largeCoverPhotoUrl: '',
      smallCoverPhotoUrl: '',
    });
    setShowResizedPhoto(!showResizedPhoto);
  };

  return (
    <div className="coverPhotoPreview__wrapper">
      <div className="coverPhotoPreview-background" />
      <div className="coverPhotoPreview">
        {isSavedToIpfs ? (
          <div className="coverPhotoPreview-loaderBlock">
            <div className="loaderBackground" />
            <div className="loaderPosition">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="coverPhotoPreview-header">
          <div />
          <h3 className="coverPhotoPreview-header__title">
            {translate.formatMessage({ id: 'wizardForm.step1.photoReview' })}
          </h3>
          <CustomBtn
            type="button"
            handleClick={() => removeIcon()}
            customClass="coverPhotoPreview-header__icon"
            iconClass="icon-close"
          />
        </div>
        <div className="coverPhotoPreview-wrapper">
          <div className="coverPhotoPreview-photoBlock">
            <h3 className="coverPhotoPreview-photoBlock__label">
              {translate.formatMessage({ id: 'wizardForm.step1.coverPhotoOnDashboard' })}
            </h3>
            <div className="coverPhotoPreview-photoBlock__smallImage">
              {resizedImage.smallCoverLoader ? <Loader /> : <img src={resizedImage.smallCoverPhotoUrl} alt="compressed" /> }
            </div>
          </div>
          <div className="coverPhotoPreview-info">
            <p className="coverPhotoPreview-info__p1">
              {translate.formatMessage({ id: 'wizardForm.step1.coverPhotoInfoP1' })}
            </p>
            <p className="coverPhotoPreview-info__p2">
              {translate.formatMessage({ id: 'wizardForm.step1.coverPhotoInfoP2' })}
            </p>
          </div>
        </div>
        <div className="coverPhotoPreview-photoBlock">
          <h3 className="coverPhotoPreview-photoBlock__label">
            {translate.formatMessage({ id: 'wizardForm.step1.coverPhotoOnExplorer' })}
          </h3>
          <div className="coverPhotoPreview-photoBlock__largeImage">
            {resizedImage.largeCoverLoader ? <Loader /> : <img src={resizedImage.largeCoverPhotoUrl} alt="compressed" />}
          </div>
        </div>
        <div className="coverPhotoPreview-btn">
          <CustomBtn
            label={translate.formatMessage(isSavedToIpfs ? { id: 'button-uploadingImage' } : { id: 'button-save' })}
            customClass={isSavedToIpfs ? 'project__loading-text' : ''}
            handleClick={saveDataToIPFS}
          />
        </div>
      </div>
    </div>
  );
};
